(function ($) {
  const nav = document.querySelector("#mainHeader");
  if (!nav) return;

  function updateNavHeight() {
    const h = Math.ceil(nav.getBoundingClientRect().height);
    document.documentElement.style.setProperty("--nav-h", h + "px");
  }

  // Run on important lifecycle events
  window.addEventListener("load", updateNavHeight);
  window.addEventListener("resize", updateNavHeight);

  if (window.jQuery) {
    $(document).on("shown.bs.collapse hidden.bs.collapse", ".navbar .collapse", updateNavHeight);
  }

  if ("MutationObserver" in window) {
    new MutationObserver(updateNavHeight).observe(nav, { childList: true, subtree: true, attributes: true });
  }

  nav.querySelectorAll("img").forEach((img) => {
    if (!img.complete) img.addEventListener("load", updateNavHeight);
  });

  setTimeout(updateNavHeight, 250);
})(jQuery);

(function ($) {
  var $mobileToggler = $("#mobileMenuToggler");
  var $mobileMenu = $("#mobileMenu");

  $mobileToggler.on("click", function (e) {
    e.preventDefault();
    var isOpen = $mobileMenu.hasClass("show");
    if (isOpen) {
      $mobileMenu.removeClass("show").slideUp(180).attr("aria-hidden", "true");
      $mobileToggler.attr("aria-expanded", "false");
    } else {
      $mobileMenu.addClass("show").slideDown(200).attr("aria-hidden", "false");
      $mobileToggler.attr("aria-expanded", "true");
    }
  });

  $(document).on("click touchstart", function (e) {
    if (!$mobileMenu.is(e.target) && $mobileMenu.has(e.target).length === 0 && !$mobileToggler.is(e.target) && $mobileToggler.has(e.target).length === 0) {
      if ($mobileMenu.hasClass("show")) {
        $mobileMenu.removeClass("show").slideUp(180).attr("aria-hidden", "true");
        $mobileToggler.attr("aria-expanded", "false");
      }
    }
  });
})(jQuery);

(function ($) {
  "use strict"; // Start of use strict

  // Scroll to top button appear
  $(document).on("scroll", function () {
    var scrollDistance = $(this).scrollTop();
    if (scrollDistance > 100) {
      $(".scroll-to-top").fadeIn();
    } else {
      $(".scroll-to-top").fadeOut();
    }
  });

  // Scroll to bottom button appear
  $(document).on("scroll", function () {
    var scrollDistance = $(this).scrollTop();
    var scrollBottom = $(window).scrollTop() + $(window).height();
    if (scrollDistance > 100) {
      $(".scroll-to-bottom").fadeIn();
    } else {
      $(".scroll-to-bottom").fadeOut();
    }
  });

  // Scroll to top
  $(document).on("click", "a.scroll-to-top", function (e) {
    var $anchor = $(this);
    $("html, body")
      .stop()
      .animate(
        {
          scrollTop: $($anchor.attr("href")).offset().top,
        },
        1000,
        "easeInOutSine",
      ); //easeInOutExpo
    e.preventDefault();
  });

  // Scroll to bottom
  $(document).on("click", "a.scroll-to-bottom", function (e) {
    var $anchor = $(this);
    $("html, body")
      .stop()
      .animate(
        {
          scrollTop: $($anchor.attr("href")).offset().top,
        },
        1000,
        "easeInOutSine",
      ); //easeInOutExpo
    e.preventDefault();
  });

  if (typeof tempusDominus !== "undefined" && tempusDominus.DefaultOptions) {
    //DATE TIME PICKER
    tempusDominus.DefaultOptions.display.icons = {
      time: "far fa-clock",
      date: "fas fa-calendar",
      up: "far fa-arrow-up",
      down: "far fa-arrow-down",
      previous: "far fa-chevron-left",
      next: "far fa-chevron-right",
      today: "far fa-calendar-check-o",
      clear: "far fa-trash",
      close: "far fa-times",
    };
  }

  if (typeof select2 !== "undefined") {
    // Select2 - generic ones

    $(".select2")
      .select2({
        theme: "bootstrap-5",
        width: "resolve",
        dropdownAutoWidth: true,
        placeholder: "Please select",
        allowClear: true,
      })
      .on("select2:open select2:select select2:unselect", forcePlaceholder);

    $(".select2.nosearch")
      .select2({
        theme: "bootstrap-5",
        minimumResultsForSearch: Infinity,
        width: "resolve",
        dropdownAutoWidth: true,
        placeholder: "Please select",
        allowClear: true,
      })
      .on("select2:open select2:select select2:unselect", forcePlaceholder);

    $(".select2.multiple")
      .select2({
        theme: "bootstrap-5",
        tags: true,
        tokenSeparators: [","],
        width: "resolve",
        placeholder: "Please select",
        dropdownAutoWidth: true,
      })
      .on("select2:open select2:select select2:unselect", forcePlaceholder);
  }

 if ($("#change-user").length > 0) {
    // Change User
    const $changeUser = $("#change-user");
    const $dropdown = $("#changeuser");
    const dropdownToggle = document.getElementById("changeUserDropdown");
    const dropdownInstance = bootstrap.Dropdown.getOrCreateInstance(dropdownToggle);

    // INIT SELECT2 (scoped)
    $changeUser
      .select2({
        theme: "bootstrap-5",
        width: "resolve",
        dropdownAutoWidth: true,
      })
      .on("select2:open select2:select select2:unselect", forcePlaceholder);

    // REDIRECT
    $changeUser.on("change", function () {
      const url = $(this).val();
      if (url) window.location.href = url;
    });

    // Track when changeUser select2 is open
    let isChangeUserSelect2Open = false;

    $changeUser.on("select2:open", function () {
      isChangeUserSelect2Open = true;
    });

    $changeUser.on("select2:close", function () {
      isChangeUserSelect2Open = false;
    });

    // Prevent dropdown closing when interacting INSIDE THIS dropdown
    $dropdown.on("click", function (e) {
      e.stopPropagation();
    });

    // Prevent Bootstrap reacting to THIS select2 only
    $(document).on("mousedown", function (e) {
      if (!isChangeUserSelect2Open) return;

      const isThisSelect2 = $(e.target).closest(".select2-container").length && $(".select2-container--open").prev()[0] === $changeUser[0];

      if (isThisSelect2) {
        e.stopPropagation();
      }
    });

    // Stop focus-based closing ONLY for this Select2
    $(document).on("focusin", function (e) {
      if (!isChangeUserSelect2Open) return;

      const isThisSelect2 = $(e.target).closest(".select2-container").length && $(".select2-container--open").prev()[0] === $changeUser[0];

      if (isThisSelect2) {
        e.stopPropagation();
      }
    });

    // Manual close (only when clicking outside THIS dropdown + THIS select2)
    $(document).on("mousedown", function (e) {
      const isInsideDropdown = $(e.target).closest("#changeuser").length;

      const isThisSelect2 = $(e.target).closest(".select2-container").length && $(".select2-container--open").prev()[0] === $changeUser[0];

      if (!isInsideDropdown && !isThisSelect2) {
        dropdownInstance.hide();
      }
    });

    // Fix position glitch ONLY for this Select2
    $(document).on("input", function (e) {
      if (!isChangeUserSelect2Open) return;

      if ($(e.target).hasClass("select2-search__field")) {
        const select2 = $changeUser.data("select2");
        if (select2) {
          select2.dropdown._positionDropdown();
        }
      }
    });
  }

  //DATATABLES added conditional
  if ($(".dataTable").length > 0) {
    // Initiate dataTables
    $(".dataTable").DataTable({
      order: [],
      lengthMenu: [
        [10, 25, 50, -1],
        [10, 25, 50, "All"],
      ],
      pageLength: 25,
      responsive: true,
    });
    //initiate table responsive after
    $(".dataTable.tblresponsive").parent().addClass("table-responsive");
  }

  // const areyousureModal = new bootstrap.Modal(document.getElementById('areyousureModal'), {
  // 	backdrop: 'static',
  // 	keyboard: true,
  // 	show: true
  // });
  // $(".modal-areyousure").click(function (e) {
  // 	e.preventDefault();
  // 	areyousureModal.show();
  // });

  //POPOVERS
  var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
  var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl);
  });

  //TOOLTIPS
  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl);
  });

  //PASSWORD Show/Hide
  $(".show_hide_password i").on("click", function (event) {
    event.preventDefault();
    var $pwField = $(this).closest(".input-group").find("input");

    // console.log($(pwField).attr('type'));
    if ($($pwField).attr("type") == "text") {
      $($pwField).attr("type", "password");
      $(this).addClass("fa-eye-slash");
      $(this).removeClass("fa-eye");
    } else if ($($pwField).attr("type") == "password") {
      $($pwField).attr("type", "text");
      $(this).removeClass("fa-eye-slash");
      $(this).addClass("fa-eye");
    }
  });

  // Same height boxes
  jQuery.fn.sameheight = function () {
    var maxHeight = 0;
    $(this).each(function () {
      // reset the height
      $(this).css({ height: "auto" });
      var thisHeight = $(this).height();

      if (thisHeight > maxHeight) {
        maxHeight = thisHeight;
      }
    });

    $(this).each(function () {
      $(this).height(maxHeight);
    });
  };

  document.querySelectorAll(".auto-scroll").forEach((input) => {
    let scrollTimer;

    input.addEventListener("mouseenter", () => {
      scrollTimer = setInterval(() => {
        if (input.scrollLeft < input.scrollWidth - input.clientWidth) {
          input.scrollLeft += 1;
        }
      }, 15);
    });

    input.addEventListener("mouseleave", () => {
      clearInterval(scrollTimer);
      input.scrollLeft = 0;
    });
  });
})(jQuery); // End of use strict

// hacks to fix aria-hidden bug in BS5 modal closing
window.addEventListener("hide.bs.modal", (event) => {
  event.target.inert = true;
});
window.addEventListener("show.bs.modal", (event) => {
  event.target.inert = false;
});

function forcePlaceholder(e) {
  const $select = $(this); // the <select>
  const data = $select.select2("data"); // current selections
  const $searchField = $select
    .data("select2") // <li class="select2-search">
    .$container.find(".select2-search__field");

  // Put the placeholder back (use data-placeholder fallback if set)
  const baseText = $select.attr("data-placeholder") || "Please select…";
  $searchField.attr("placeholder", data.length ? "Click or type to select more…" : baseText);

  // Stop the 0.75 em shrink
  $searchField.css({ minWidth: "100px", width: "100%" });
}

function initTableAutoResize(tableSelector, options = {}) {
  const table = document.querySelector(tableSelector);
  if (!table) return;

  const minInputWidth = options.minInputWidth || 100; // default min-width for inputs & selects
  const minTextareaWidth = options.minTextareaWidth || 200; // wider min-width for textareas

  // --- INPUTS ---
  table.querySelectorAll('input[type="text"], input[type="number"]').forEach((input) => {
    input.style.minWidth = minInputWidth + "px";

    const resizeInput = () => {
      input.style.width = "1px"; // reset
      input.style.width = Math.max(input.scrollWidth + 2, minInputWidth) + "px";
      input.style.minWidth = "100%";
    };

    resizeInput(); // initial
    input.addEventListener("input", resizeInput);
  });

  // --- TEXTAREAS ---
  table.querySelectorAll("textarea").forEach((textarea) => {
    textarea.style.minWidth = minTextareaWidth + "px";
    textarea.style.overflowY = "hidden"; // hide vertical scrollbar
    textarea.style.resize = "vertical"; // allow manual resize
  });

  // --- SELECTS / SELECT2 ---
  table.querySelectorAll("select").forEach((select) => {
    select.style.minWidth = minInputWidth + "px";
    select.style.minWidth = "100" + "%";
    select.style.width = "auto";

    // If using Select2
    if (typeof $ !== "undefined" && $(select).hasClass("select2-hidden-accessible")) {
      $(select).select2({
        theme: "bootstrap-5",
        width: "auto",
        dropdownAutoWidth: true,
      });

      const container = $(select).next(".select2-container");
      container.css("flex", "0 0 auto");
      container.css("min-width", minInputWidth + "px");
    }
  });
}

function attachAllOptionBehavior($select, allValue = "all") {
  // Prevent ALL from being unselected
  $select.on("select2:unselecting", function (e) {
    if (e.params.args.data.id === allValue) {
      e.preventDefault();
    }
  });

  // Clicking ALL selects all other options
  $select.on("select2:select", function (e) {
    if (e.params.data.id === allValue) {
      // Get all current option values except ALL dynamically
      const allOptions = $select
        .find("option")
        .not(`[value="${allValue}"]`)
        .map((i, opt) => $(opt).val())
        .get();
      $select.val(allOptions).trigger("change.select2");
    }
  });
}

function enableSelectAll($select, allValue = "all") {
  $select.select2({ placeholder: "Select options" });

  $select.on("change", function () {
    const selected = $(this).val() || [];
    const allOptions = $select
      .find("option")
      .map((i, opt) => $(opt).val())
      .get();

    if (selected.includes(allValue) && selected.length < allOptions.length) {
      // Select all options
      $(this).val(allOptions).trigger("change.select2");
    } else if (!selected.includes(allValue) && selected.length === allOptions.length - 1) {
      // All except ALL selected → also select ALL
      $(this).val(allOptions).trigger("change.select2");
    } else if (selected.includes(allValue) && selected.length < allOptions.length) {
      // Deselect ALL if user unchecked some options
      $(this)
        .val(selected.filter((v) => v !== allValue))
        .trigger("change.select2");
    }
  });
}
